import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {SingleDatePicker} from 'react-dates';
import {DatePicker} from './RenderDatePicker.style';
import {DEFAULT_DATE_FORMAT} from '../../constants/constant';

class RenderDatePicker extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      focused: null
    };
    this.handleOnFocusChange = this.handleOnFocusChange.bind(this);
  }

  handleOnFocusChange(value) {
    this.setState({ focused: value.focused });
  }

  render() {
    const {date, input, isDayBlocked, onDateChange} = this.props;
    return (
      <DatePicker>
        <SingleDatePicker
          date={date}
          onDateChange={onDateChange}
          focused={this.state.focused}
          onFocusChange={this.handleOnFocusChange}
          id={input.name}
          required={true}
          numberOfMonths={1}
          hideKeyboardShortcutsPanel={true}
          displayFormat={DEFAULT_DATE_FORMAT}
          isDayBlocked={isDayBlocked}
        />
      </DatePicker>
    );
  }
}

RenderDatePicker.propTypes = {
  input: PropTypes.object.isRequired,
  date: PropTypes.object.isRequired,
  openingTimes: PropTypes.object,
  serviceTypeValue: PropTypes.string,
  onDateChange: PropTypes.func.isRequired,
  isDayBlocked: PropTypes.func
};

export default RenderDatePicker;



// WEBPACK FOOTER //
// ./components/ReduxForm/RenderDatePicker.js